export default {
  files(state) {
    return state.files;
  },
  invoices(state) {
    return state.files.filter((file) => {
      return file.tag == 'invoice'
    });
  },
};